import { render, staticRenderFns } from "./SplitBanner.vue?vue&type=template&id=6ed72793"
import script from "./SplitBanner.vue?vue&type=script&lang=js"
export * from "./SplitBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports